export const pengajuanReducer = (state, action) => {
  switch (action.type) {
    case "UBAH_DATA":
      return {
        ...state,
        pengajuanData: { ...state.pengajuanData, ...action.payload },
      };
    case "UBAH_DATA_KATEGORI":
      // JIKA KATEGORI BERUBAH MAKA DATA TERKAIT KOSONG
      let data = {};
      if (!action.payload.kategori.includes("online")) {
        data.link_web = "";
      }
      if (!action.payload.kategori.includes("elektronik")) {
        data.link_youtube = "";
        data.no_frekuensi = "";
      }
      if (!action.payload.kategori.includes("cetak")) {
        data.jumlah_oplah_dan_sebaran_media = "";
      }
      return {
        ...state,
        pengajuanData: { ...state.pengajuanData, ...action.payload, ...data },
      };
    case "UBAH_DOKUMEN":
      return {
        ...state,
        pengajuanData: {
          ...state.pengajuanData,
          dokumen: {
            ...state.pengajuanData.dokumen,
            ...action.payload,
          },
        },
      };
    case "UBAH_DATA_ALAMAT":
      return {
        ...state,
        pengajuanData: {
          ...state.pengajuanData,
          alamat_kantor_media_perusahaan: {
            ...state.pengajuanData.alamat_kantor_media_perusahaan,
            ...action.payload,
          },
        },
      };
    case "TAMBAH_KBLI":
      return {
        ...state,
        pengajuanData: {
          ...state.pengajuanData,
          kbli: [...state.pengajuanData.kbli, action.payload],
        },
      };
    case "HAPUS_KBLI":
      return {
        ...state,
        pengajuanData: {
          ...state.pengajuanData,
          kbli: action.payload,
        },
      };
    case "UPDATE_KBLI":
      return {
        ...state,
        pengajuanData: {
          ...state.pengajuanData,
          kbli: action.payload,
        },
      };
    case "UBAH_STATUS":
      return {
        ...state,
        statusPengajuan: action.payload,
      };
    case "RESET_PENGAJUAN":
      const data_reset = {
        nama_perusahaan: "",
        nama_media: "",
        alamat_kantor_media_perusahaan: {
          provinsi: "9",
          kota: "",
          kecamatan: "",
          kelurahan: "",
          jalan: "",
        },
        link_web: "http://www.",
        logo: "",
        email_perusahaan: "",
        status_media: "",
        nama_pimred: "",
        nohp_pimred: "",
        nama_wartawan: "",
        nohp_wartawan: "",
        npwp_perusahaan: "",
        no_akta: "",
        tahun_berdiri: "",
        nib: "",
        kbli: [],
        nama_bank: "",
        no_rekening: "",
        latitude: -2.120276,
        longitude: 106.113607,
        kategori: [],
        link_youtube: "",
        no_frekuensi: "",
        jumlah_oplah_dan_sebaran_media: "",
        dokumen: {
          foto_kantor: "",
          foto_plang_papan_nama: "",
          surat_permohonan_kerjasama: "",
          surat_tugas_wartawan: "",
          kartu_anggota_wartawan: "",
          ktp_pimpinan: "",
          ktp_wartawan: "",
          akta_pendirian_perusahaan: "",
          bukti_pengesahan_kemenkumham: "",
          nib: "",
          npwp_perusahaan: "",
          // spt_tahun_terakhir: "",
          referensi_bank_dan_nomor_rekening: "",
          profil_media: "",
          izin_siaran: "",
          izin_penyelenggaraan_penyiaran: "",
        },
      };

      return {
        ...state,
        pengajuanData: data_reset,
      };

    default:
      return state;
  }
};

export const lokasiReducer = (state, action) => {
  switch (action.type) {
    case "UBAH_LOKASI":
      return { ...state, ...action.payload };

    default:
      return state;
  }
};

export const mediaReducer = (state, action) => {
  switch (action.type) {
    case "UBAH_DATA":
      return { ...state, ...action.payload };

    default:
      return state;
  }
};

export const errorReducer = (state, action) => {
  switch (action.type) {
    case "UBAH_ERROR":
      return { ...state, ...action.payload };

    default:
      return state;
  }
};
